import { IconButton, Button, Tooltip } from '@material-ui/core';
import React from 'react';
import GetAppIcon from '@material-ui/icons/GetApp';

const CSVDialog = ({ columns, rows, additionalData, filename }) => {

	const exportCSV = () => {
		let csv = [];
		let ignoreidx = [];
		const csv_columns = columns.filter((c, idx) => {
			if (c.noprint) ignoreidx.push(idx);
			return !c.noprint
		}).map((item) => item.label);
		const csv_rows = rows.displayData.map((row) => {
			let res = []
			row.data.forEach((item, idx) => {
				if (!ignoreidx.includes(idx)) {
					if (!item) {
						res.push('')
					} else if (!['string', 'number'].includes(typeof item)) {
						res.push(`"${item.props.title}"`)
					} else {
						res.push(`"${item}"`);
					}
				}
			})
			return res;
		}).join('\r');
		if (additionalData) csv.push(additionalData.join(','));
		csv.push(csv_columns.join(','));
		csv.push(csv_rows);
		csv = csv.join('\n');
		downloadCSV(csv, filename + '.csv');
	}

	const downloadCSV = (csv, filename) => {
		var csvFile;
		var downloadLink;

		csvFile = new Blob([csv], { type: "text/csv" });
		downloadLink = document.createElement("a");
		downloadLink.download = filename;
		downloadLink.href = window.URL.createObjectURL(csvFile);
		downloadLink.style.display = "none";
		document.body.appendChild(downloadLink);
		downloadLink.click();
	}


	return (
		< >
			<Tooltip title="CSV export">
				<IconButton onClick={exportCSV}>
					<GetAppIcon />
				</IconButton>
			</Tooltip>
		</ >
	)
}

CSVDialog.propTypes = {
}

export default CSVDialog
